<rt-dialog-header [heading]="state.title">
  {{ state.subtitle }}
</rt-dialog-header>

@if (state.form) {
  <rt-dialog-body layout-vertical>
    <rti-dynamic-form [form]="state.form" />
    <rti-error-messages-wrapper [errors]="state.errors" />
  </rt-dialog-body>
}

@if (state.form) {
  <rt-dialog-footer>
    <rt-button variant="plain" [disabled]="state.saving" (click)="close()">
      {{ 'rti.common.cancel' | translate }}
    </rt-button>

    <rt-button
      variant="primary"
      [disabled]="!state.form.valid || state.formLoading"
      [loading]="state.saving"
      (click)="send()"
    >
      {{ 'rti.common.send' | translate }}
    </rt-button>
  </rt-dialog-footer>
}
